import { EraParser as r } from "./ghl-ui.es1580.js";
import { YearParser as e } from "./ghl-ui.es1581.js";
import { LocalWeekYearParser as o } from "./ghl-ui.es1582.js";
import { ISOWeekYearParser as m } from "./ghl-ui.es1583.js";
import { ExtendedYearParser as a } from "./ghl-ui.es1584.js";
import { QuarterParser as t } from "./ghl-ui.es1585.js";
import { StandAloneQuarterParser as n } from "./ghl-ui.es1586.js";
import { MonthParser as i } from "./ghl-ui.es1587.js";
import { StandAloneMonthParser as s } from "./ghl-ui.es1588.js";
import { LocalWeekParser as p } from "./ghl-ui.es1589.js";
import { ISOWeekParser as P } from "./ghl-ui.es1590.js";
import { DateParser as f } from "./ghl-ui.es1591.js";
import { DayOfYearParser as w } from "./ghl-ui.es1592.js";
import { DayParser as d } from "./ghl-ui.es1593.js";
import { LocalDayParser as S } from "./ghl-ui.es1594.js";
import { StandAloneLocalDayParser as c } from "./ghl-ui.es1595.js";
import { ISODayParser as M } from "./ghl-ui.es1596.js";
import { AMPMParser as l } from "./ghl-ui.es1597.js";
import { AMPMMidnightParser as u } from "./ghl-ui.es1598.js";
import { DayPeriodParser as D } from "./ghl-ui.es1599.js";
import { Hour1to12Parser as y } from "./ghl-ui.es1600.js";
import { Hour0to23Parser as O } from "./ghl-ui.es1601.js";
import { Hour0To11Parser as T } from "./ghl-ui.es1602.js";
import { Hour1To24Parser as I } from "./ghl-ui.es1603.js";
import { MinuteParser as Y } from "./ghl-ui.es1604.js";
import { SecondParser as h } from "./ghl-ui.es1605.js";
import { FractionOfSecondParser as k } from "./ghl-ui.es1606.js";
import { ISOTimezoneWithZParser as A } from "./ghl-ui.es1607.js";
import { ISOTimezoneParser as H } from "./ghl-ui.es1608.js";
import { TimestampSecondsParser as L } from "./ghl-ui.es1609.js";
import { TimestampMillisecondsParser as W } from "./ghl-ui.es1610.js";
var sr = {
  G: new r(),
  y: new e(),
  Y: new o(),
  R: new m(),
  u: new a(),
  Q: new t(),
  q: new n(),
  M: new i(),
  L: new s(),
  w: new p(),
  I: new P(),
  d: new f(),
  D: new w(),
  E: new d(),
  e: new S(),
  c: new c(),
  i: new M(),
  a: new l(),
  b: new u(),
  B: new D(),
  h: new y(),
  H: new O(),
  K: new T(),
  k: new I(),
  m: new Y(),
  s: new h(),
  S: new k(),
  X: new A(),
  x: new H(),
  t: new L(),
  T: new W()
};
export {
  sr as parsers
};
